import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

const photoswipeElement = document.querySelector('.pswp');
let lightBox;
/**
 * Create a Photoswipe gallery from an element that contains multiple <a> tags that should open images e.g. a slick carousel
 *
 * @param {HTMLElement} element
 * @returns function
 */
export default function(element) {
    if (!photoswipeElement) {
        console.error('No photoswipe element found');
        return false;
    }
    if (!element) {
        console.error('No target element found');
        return false;
    }

    // Build array of photos for Photoswipe to use as a gallery
    let photos = [];
    element.querySelectorAll('a').forEach(item => {
        // If it's a cloned slide, don't use it as it will be a duplicate
        if (item.parentElement.classList.contains('slick-cloned')) {
            return;
        }
        let photo = {
            src : item.getAttribute('href'),
        };
        if (item.dataset.size) {
            let size = item.dataset.size.split('x');
            photo.w = parseInt(size[0]),
            photo.h = parseInt(size[1])
        }

        photos.push(photo);
        item.dataset.photoswipeIndex = photos.length - 1;
    });

    function isMobileGalleryVisible() {
        const mobileGallery = document.querySelector('.slick-news-gallery__mobile-gallery');
        return mobileGallery && window.getComputedStyle(mobileGallery).display !== 'none';
    }

    if (isMobileGalleryVisible()) {
        initializeSlickCarousel();
    } else {
        setupDesktopGallery();
    }

    function initializeSlickCarousel() {
        $('.slick-news-gallery__mobile-gallery').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            mobileFirst: true
        });

        $('.slick-news-gallery__mobile-gallery').on('init reInit afterChange', setupSlickEvents);
        setupSlickEvents();

        function setupSlickEvents() {
            $('.slick-news-gallery__mobile-gallery a').off('click').on('click', function (event) {
                event.preventDefault();
                const index = $(this).closest('.slick-slide').data('slick-index');
                openPhotoSwipe(index);
            });
        }
        
        function openPhotoSwipe(index) {
            const options = {
                index: index,
                bgOpacity: 0.7,
                showHideOpacity: true,
            };

            lightBox = new PhotoSwipe(photoswipeElement, PhotoSwipeUI_Default, photos, options);

            lightBox.listen('afterChange', function () {
                updateSlickSlide(lightBox.getCurrentIndex());
            });

            lightBox.init();
        }

        function updateSlickSlide(index) {
            $('.slick-news-gallery__mobile-gallery').slick('slickGoTo', index);
        }
    }

    function setupDesktopGallery() {
        element.querySelectorAll('a').forEach(item => {
            item.addEventListener('click', function (event) {
                event.preventDefault();

                const options = {
                    index: parseInt(item.dataset.photoswipeIndex, 10),
                    bgOpacity: 0.7,
                    showHideOpacity: true
                };

                lightBox = new PhotoSwipe(photoswipeElement, PhotoSwipeUI_Default, photos, options);
                lightBox.init();
            });
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/create-photoswipe-gallery.js